// MARK://dhk8/admin-shell/lib/queries/suppliers
// Queries tipadas de proveedores — F2.2 / ADR-0009. El Admin lee proveedores por
// el grafo (erp-suppliers), tenant del JWT (RLS). F8.x: escrituras también por el grafo.
import { graphql } from '../../gql/index.js'

export const AdminSuppliersQuery = graphql(`
  query AdminSuppliers($limit: Int) {
    suppliers(limit: $limit) {
      items {
        id
        tenantId
        networkId
        legalName
        rfc
        type
        active
        archived
        tags
        addresses {
          id
          type
          line1
          line2
          city
          state
          zip
          country
        }
        createdAt
        updatedAt
      }
    }
  }
`)

export const AdminSupplierQuery = graphql(`
  query AdminSupplier($id: ID!) {
    supplier(id: $id) {
      id
      tenantId
      networkId
      legalName
      rfc
      type
      active
      archived
      tags
      addresses {
        id
        type
        line1
        line2
        city
        state
        zip
        country
      }
      createdAt
      updatedAt
    }
  }
`)


export const AdminCreateSupplierMutation = graphql(`
  mutation AdminCreateSupplier($input: ErpSupplierCreateInput!) {
    createSupplier(input: $input) {
      id
      tenantId
      networkId
      legalName
      rfc
      type
      active
      archived
      tags
      addresses {
        id
        type
        line1
        line2
        city
        state
        zip
        country
      }
      createdAt
      updatedAt
    }
  }
`)

export const AdminUpdateSupplierMutation = graphql(`
  mutation AdminUpdateSupplier($id: ID!, $input: ErpSupplierUpdateInput!) {
    updateSupplier(id: $id, input: $input) {
      id
      tenantId
      networkId
      legalName
      rfc
      type
      active
      archived
      tags
      addresses {
        id
        type
        line1
        line2
        city
        state
        zip
        country
      }
      createdAt
      updatedAt
    }
  }
`)

export const AdminDeleteSupplierMutation = graphql(`
  mutation AdminDeleteSupplier($id: ID!) {
    deleteSupplier(id: $id)
  }
`)

// ── F8.x: direcciones de proveedor por el grafo (erp-suppliers, tenant del JWT, RLS) ──
export const AdminCreateSupplierAddressMutation = graphql(`
  mutation AdminCreateSupplierAddress($supplierId: ID!, $input: ErpSupplierAddressInput!) {
    createSupplierAddress(supplierId: $supplierId, input: $input) {
      id
      type
      line1
      line2
      city
      state
      zip
      country
    }
  }
`)

export const AdminUpdateSupplierAddressMutation = graphql(`
  mutation AdminUpdateSupplierAddress($id: ID!, $input: ErpSupplierAddressInput!) {
    updateSupplierAddress(id: $id, input: $input) {
      id
      type
      line1
      line2
      city
      state
      zip
      country
    }
  }
`)

export const AdminDeleteSupplierAddressMutation = graphql(`
  mutation AdminDeleteSupplierAddress($id: ID!) {
    deleteSupplierAddress(id: $id)
  }
`)

// B / decisión Gustavo 2026-06-22: catálogo de compra de un insumo (qué
// proveedores lo surten, presentación, precio). Lectura + upsert/borrado por el
// grafo (erp-suppliers, tenant del JWT, RLS).
export const AdminSupplierItemsQuery = graphql(`
  query AdminSupplierItems($productId: ID!) {
    supplierItems(productId: $productId) {
      id
      productId
      supplierId
      supplierAddressId
      presentationId
      supplierSku
      unitCostCents
      currency
      leadDays
      isPreferred
      active
    }
  }
`)

export const AdminUpsertSupplierItemMutation = graphql(`
  mutation AdminUpsertSupplierItem($input: ErpSupplierItemInput!) {
    upsertSupplierItem(input: $input) {
      id
      productId
      supplierId
      supplierAddressId
      presentationId
      supplierSku
      unitCostCents
      currency
      leadDays
      isPreferred
      active
    }
  }
`)

export const AdminDeleteSupplierItemMutation = graphql(`
  mutation AdminDeleteSupplierItem($id: ID!) {
    deleteSupplierItem(id: $id)
  }
`)

